var render = function render(){var _vm=this,_c=_vm._self._c;return _c('r-block',{attrs:{"col":"","top":"","no-padding":""}},_vm._l((_vm.objectCards),function(card){return _c('sc-object-card',{key:card.id,attrs:{"object-card":card}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }